import '../styles/about.css';

const About = () => {
  return (
    <section id="about-section" className="about-section">
      <div className="container">
        <div className="about-grid">
          <div className="about-label">About CARPE</div>

          <div className="about-content">
            <h2>Helping People Move From Hardship to Hope</h2>

            <p>
              CARPE Ministries is a 501c3 nonprofit organization providing assistance,
              resources, prevention, education, and support services to people facing
              hardship in their communities.
            </p>

            <p>
              We believe in putting our boots to the ground, helping educate,
              encourage, and connect people with resources that can change lives.
            </p>

            <div className="about-points">
              <span>Community Awareness</span>
              <span>Resources</span>
              <span>Prevention</span>
              <span>Education</span>
              <span>Support Services</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About